import React from "react";
import { AppBreadcrumbs } from "_lib";
import { Flex, Typography } from "antd";
import PropTypes from "prop-types";
import {
  StyledAppPageHeader,
  StyledAppPageHeaderDivider,
  StyledAppPageHeaderTitle,
} from "./index.styled";

const AppPageHeader = (props) => {
  const {
    title,
    subtitle,
    urlToNameMap,
    extra,
    showDivider,
    showBreadCrumbs,
    showBreadCrumbsOnly,
    breadcrumbItems,
  } = props;

  return (
    <StyledAppPageHeader vertical gap={16}>
      {showBreadCrumbs && (
        <AppBreadcrumbs
          className="app-breadcrumbs-page-header"
          urlToNameMap={urlToNameMap}
          items={breadcrumbItems}
        />
      )}
      {!showBreadCrumbsOnly && (
        <Flex vertical gap={8}>
          <Flex gap={8} align="center" justify="space-between">
            <StyledAppPageHeaderTitle level={1}>
              {title}
            </StyledAppPageHeaderTitle>
            {extra && extra}
          </Flex>

          {subtitle && <Text type="secondary">{subtitle}</Text>}
          {showDivider && <StyledAppPageHeaderDivider />}
        </Flex>
      )}
    </StyledAppPageHeader>
  );
};
const { Text } = Typography;

AppPageHeader.propTypes = {
  urlToNameMap: PropTypes.object.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  extra: PropTypes.node,
  showDivider: PropTypes.bool,
  showBreadCrumbs: PropTypes.bool,
  showBreadCrumbsOnly: PropTypes.bool,
  breadcrumbItems: PropTypes.array,
};

AppPageHeader.defaultProps = {
  title: "",
  subtitle: "",
  extra: null,
  showDivider: false,
  showBreadCrumbs: false,
  showBreadCrumbsOnly: false,
};

export default AppPageHeader;
